var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardPpLogo = function SvgCardPpLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "#B4A97D",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.318 19.435c5.813 0 6.182-3.828 6.182-5.225 0-1.398-.37-5.21-6.182-5.21h-3.152v19.132h-1.333V9l-4.798 1.37.249.834 2.103-.6V28.13H11.5V29h10.444v-.87h-2.889v-8.696zm-.486-9.566c3.334 0 3.779 3.024 3.779 4.342s-.445 4.355-3.779 4.355h-1.777V9.869z",
    opacity: 0.7
  })));
};
export default SvgCardPpLogo;